<template>
  <div id="app">
    <TopNav/>
<!--    <transition-->
<!--      name="page"-->
<!--      mode="out-in"-->
<!--    >-->
    <router-view/>
<!--    </transition>-->
  </div>
</template>

<script>
import TopNav from "./components/TopNav";
export default {
  name: 'App',
  components: {TopNav}
}
</script>

<style>
#app {
  //font-family: Lato, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  width: 100%;

}
.page-enter-active,
.page-leave-active {
  /*transition: transform 0.3s ease-in-out;*/
  transition: opacity 0.3s, transform 0.3s;
}

.page-enter {
  opacity: 0;
  transform: translateX(30%);
}
.page-leave-to {
  /*transform: translateX(100%);*/
  opacity: 1;
  transform: translateX(0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue